import React from "react";

export const LaIcon = ({ icon, ...otherProps }) => (
    <i style={{fontSize: '30px'}} className={`la la-${icon}`}></i>
);
